import createCache from '@emotion/cache';

/**
 * Creates the emotion cache by creating a meta tag at the top of the <head> and inserting the
 * result of {@link createCache} into it.  This ensures that MUI styles are loaded first, while
 * allowing developers to more easily override MUI style definitions with inline styles or other
 * style frameworks, like CSS modules.
 */
export const createEmotionCache = () => {
  if (typeof document !== 'undefined') {
    const emotionInsertionPoint = document.querySelector<HTMLMetaElement>(
      'meta[name="emotion-insertion-point"]',
    );
    return createCache({ insertionPoint: emotionInsertionPoint ?? undefined, key: 'mui-style' });
  }
  return createCache({ key: 'mui-style' });
};
